import React, { useState, useEffect, useRef, useContext } from 'react';
import { auth, http, ConfigContext } from '../lib';

export const NavbarTop = () => {
    const { config } = useContext(ConfigContext);
    const [user, setUser] = useState({ firstName: '', lastName: '', profilePicture: '' });
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const logoutButtonRef = useRef(null);

    useEffect(() => {
        const fetchUserProfile = async () => {
            try {
                const response = await http.get({}, `${config.uri.base}/auth/profile`);
                setUser(response);
            } catch (error) {
                console.error('Failed to fetch user profile:', error);
            }
        };

        fetchUserProfile();

        const handleOutsideClick = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [config.uri.base]);

    const handleDropdownToggle = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleLogout = () => {
        auth.logout();
        window.location.href = '/';
    };

    return (
        <header className='h-[100px] top-0 shadow-lg'>
            <div className='px-[20px] h-full flex flex-row justify-end items-center'>
                <div className='flex items-center gap-2'>
                    <span className="text-black">{user.firstName} {user.lastName}</span>
                    <div className='relative'>
                        <img
                            src={user.profilePicture}
                            alt="Profile"
                            className="w-[40px] h-[40px] rounded-full cursor-pointer"
                            onClick={handleDropdownToggle}
                        />
                        {isDropdownOpen && (
                            <div ref={dropdownRef} className="absolute right-0 mt-2 py-2 w-48 bg-white border rounded shadow-xl">
                                <button
                                    ref={logoutButtonRef}
                                    onClick={handleLogout}
                                    className='block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-200'
                                >
                                    Logout
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
};
